<style lang="css">
@import '../css/bootstrap.css';
@import '../css/bootstrap-vue.css';
@import '../css/admin-table.css';
</style>
<style lang="scss" scoped>
@import '../css/admin.scss';
</style>
<template>
  <div class="admin-page">
    <admin-header :tit="this.title"></admin-header>
    <admin-side></admin-side>
    <section class="admin-template">
      <h2 class="sub-tit">전문가 관리</h2>
      <div class="contents">
        <b-container fluid>
          <!-- User Interface controls -->
            <b-row>
             <b-col class="my-1 text-left type-box">
               <b-form-group
                label="전문가 Type"
                label-for="form-select"
                label-cols-sm="3"
                label-align-sm="left"
                label-size="sm"
                class="mb-0 "
              >
               <b-form-select size="sm" class="item-select" id="form-select" v-model="typeSelected" :options="itemOptions"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="my-1 text-left type-box select-box">
               <b-form-select size="sm" class="item-select" id="form-address-first" v-model="addressCitySelected" :options="addressCity"></b-form-select>
            </b-col>
            <b-col class="my-1 text-left type-box select-box">
               <b-form-select size="sm" class="item-select" id="form-address-second" v-model="addressCountySelected" :options="addressCounty"></b-form-select>
            </b-col>
            <b-col class="my-1 filter-box mngm-search-area">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    type="search"
                    placeholder="업체명 또는 이름을 검색 해 주세요."
                    v-model="searchText"
                  ></b-form-input>
                  <b-button size="sm" @click="itemFilter()" class="search-btn">검색</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Main table element -->
          <b-table
            id="expert-management"
            :items="items"
            :fields="fields"
            stacked="md"
            show-empty
            small
          >
            <template #cell(proPicFileNm)="row">
              <div class="thumb-img" v-if="row.value === ''">
                <img :src="require('../img/main/pro_defualt-img.png')">
              </div>
              <div class="thumb-img" v-else>
                <img :src="imgUrl + '/' + row.value">
              </div>
            </template>
            <template #cell(proNm)="row">
              {{ row.value }}
            </template>
            <template #cell(proTel)="row">
              {{ row.value }}
            </template>
            <template #cell(proRegion)="row">
              {{ row.value }}
            </template>
            <template #cell(actions)="row">
              <!-- <input type="text" class="default-input" :value="row.index" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '')"> -->
              <b-button size="sm" @click="modifyItem(row.item, row.index)" class="save-btn mr-1">수정</b-button>
              <b-button size="sm" @click="deleteItem(row.item, row.index)" class="deleat-btn">삭제</b-button>
            </template>
          </b-table>
           <b-row>
            <b-col lg="12" class="my-1 text-right">
              <b-button variant="primary" @click="newItem()" class="new-item-btn">신규</b-button>
            </b-col>
          </b-row>
          <b-modal
          id="add-management"
          class="item-modal management-modal"
          size="lg"
          title="전문가 추가하기"
          @show="resetModal"
          @hidden="resetModal"
          >
            <b-row class="modal-top-row">
              <b-col sm="9" class="my-1 modal-top-area">
                <div class="my-1 modal-top-right city">
                  <label>전문가타입</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.proType" :options="infoModal.typeKinds"></b-form-select>
                </div>
                <div class="my-1 text-left modal-top-left">
                  <label>업체명/이름</label>
                  <b-form-input
                    v-model="infoModal.name"
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>연락처</label>
                  <b-form-input
                    v-model="infoModal.tel"
                  ></b-form-input>
               </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="3" class="my-1">
                <div class="my-1 modal-top-right city">
                  <label>담당구역</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.addressCitySelected" :options="infoModal.addressCity"></b-form-select>
                </div>
              </b-col>
              <b-col sm="3" class="my-1">
                <div class="my-1 modal-top-right county">
                  <label style="color:#fff">구</label>
                  <b-form-select size="sm" class="item-select" id="form-select-county" v-model="infoModal.addressCountySelected" :options="infoModal.addressCounty"></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>홈페이지 주소</label>
                  <b-form-input
                    v-model="infoModal.url"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-third-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left desc search">
                  <label>사무실 주소</label>
                  <b-form-input
                    :value="infoModal.address"
                    disabled
                    @click="showModal()"
                    class="default"
                    placeholder="찾기 버튼을 눌러 주소를 검색해주세요."
                  ></b-form-input>
                  <button type="button" class="default-btn address-search" @click="showModal()">찾기</button>
                  <vuejs-address id="address1" class="w-100per" name="address" v-model="infoModal.address" :show="layerPopPost" @close="getPostcode"></vuejs-address>
                </div>
                <div class="my-1 text-left desc detail">
                  <label>상세 주소</label>
                  <b-form-input
                    v-model="infoModal.addressDetail"
                    class="default"
                    placeholder="상세주소를 입력해주세요"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" class="my-1 modal-third-area">
                <label>대표 사진</label>
                <div class="my-1 text-left desc search">
                  <VueFileAgent
                  ref="vueFileAgent"
                  :theme="'list'"
                  :multiple="false"
                  :deletable="true"
                  :meta="true"
                  :accept="'image/*'"
                  :maxSize="'10MB'"
                  :maxFiles="1"
                  :helpText="'첨부할 사진을 마우스로 끌어서 추가할 수 있습니다.'"
                  :errorText="{
                    type: '이미지만 업로드가 가능합니다.',
                    size: '사진크기는 10MB 를 넘을 수 없습니다.',
                  }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="fileRecords"
                  ></VueFileAgent>
                  <div class="text-right save-btn-area">
                    <b-button
                    variant="primary"
                    class="default-btn address-search btn-primary"
                    @click="modalAdd()"
                  >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
          <b-modal id="modify-management" size="lg" class="item-modal management-modal" :title="infoModal.title" ok-only>
            <b-row class="modal-top-row">
              <b-col sm="9" class="my-1 modal-top-area">
                <div class="my-1 modal-top-right city">
                  <label>전문가타입</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.proType" :options="infoModal.typeKinds"></b-form-select>
                </div>
                <div class="my-1 text-left modal-top-left">
                  <label>업체명/이름</label>
                  <b-form-input
                    v-model="infoModal.name"
                  ></b-form-input>
                </div>
                <div class="my-1 text-left modal-top-center">
                  <label>연락처</label>
                  <b-form-input
                    v-model="infoModal.tel"
                  ></b-form-input>
               </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="3" class="my-1">
                <div class="my-1 modal-top-right city">
                  <label>담당구역</label>
                  <b-form-select size="sm" class="item-select" id="form-select-city" v-model="infoModal.addressCitySelected" :options="infoModal.addressCity"></b-form-select>
                </div>
              </b-col>
              <b-col sm="3" class="my-1">
                <div class="my-1 modal-top-right county">
                  <label style="color:#fff">구</label>
                  <b-form-select size="sm" class="item-select" id="form-select-county" v-model="infoModal.addressCountySelected" :options="infoModal.addressCounty"></b-form-select>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-second-row">
              <b-col sm="12" class="my-1 modal-second-area">
                <div class="my-1 text-left">
                  <label>홈페이지 주소</label>
                  <b-form-input
                    v-model="infoModal.url"
                  ></b-form-input>
                </div>
              </b-col>
            </b-row>
            <b-row class="modal-third-row">
              <b-col sm="12" class="my-1 modal-third-area">
                <div class="my-1 text-left desc search">
                  <label>사무실 주소</label>
                  <b-form-input
                    :value="infoModal.address"
                    disabled
                    @click="showModal()"
                    class="default"
                    placeholder="찾기 버튼을 눌러 주소를 검색해주세요."
                  ></b-form-input>
                  <button type="button" class="default-btn address-search" @click="showModal()">찾기</button>
                  <vuejs-address id="address" class="w-100per" name="address" v-model="infoModal.address" :show="layerPopPost" @close="getPostcode"></vuejs-address>
                </div>
                <div class="my-1 text-left desc detail">
                  <label>상세 주소</label>
                  <b-form-input
                    v-model="infoModal.addressDetail"
                    class="default"
                    placeholder="상세주소를 입력해주세요"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" class="my-1 modal-third-area">
                <label>대표 사진</label>
                <div class="my-1 text-left desc search">
                  <VueFileAgent
                  ref="vueFileAgent"
                  :theme="'list'"
                  :multiple="false"
                  :deletable="true"
                  :meta="true"
                  :accept="'image/*'"
                  :maxSize="'10MB'"
                  :maxFiles="1"
                  :helpText="'첨부할 사진을 마우스로 끌어서 추가할 수 있습니다.'"
                  :errorText="{
                    type: '이미지만 업로드가 가능합니다.',
                    size: '사진크기는 10MB 를 넘을 수 없습니다.',
                  }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="fileRecords"
                  ></VueFileAgent>
                  <div class="text-right save-btn-area">
                    <b-button
                    variant="primary"
                    class="default-btn address-search btn-primary"
                    @click="modifySave()"
                  >
                    저장
                  </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
            <template #modal-footer>
              <b-row class="modify-footer">
              </b-row>
            </template>
          </b-modal>
        </b-container>
      </div>
    </section>
  </div>
</template>
<script>
import AdminHeader from '@/components/AdminHeader'
import AdminSide from '@/components/AdminSide'
import DaumPostcode from '@/components/DaumPostcode'
// https://bootstrap-vue.org/docs/components/table
import { mapGetters } from 'vuex'

export default {
  name: 'ExpertManagement',
  components: {
    'admin-header': AdminHeader,
    'admin-side': AdminSide,
    'vuejs-address': DaumPostcode
  },
  data () {
    return {
      title: '관리자 페이지',
      layerPopPost: false,
      typeSelected: '0',
      addressCitySelected: '',
      addressCountySelected: '',
      searchText: '',
      addressCity: [
        { value: '', text: '시도 선택' }
      ],
      addressCounty: [
        { value: '', text: '구군 선택' }
      ],
      itemOptions: [
        /* { value: '0', text: '공인중개사' },
        { value: '1', text: '변호사' },
        { value: '2', text: '법무사' } */
      ],
      selected: [],
      addFileRecords: [],
      modifyFileRecords: [],
      fileRecordsForUpload: [],
      fileRecordsForDelete: [],
      innerRegion: '',
      innerControllFlag: false,
      fileRecords: [
        {
          name: 'img_start.png',
          url: 'file:///C://uploads/pro_images/7/img_start.png',
          lastModified: '',
          size: '10000',
          type: 'image/png',
          ext: 'png'
        }
      ],
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent' },
      imgUrl: this.$store.state.common.urlpath,
      uploadUrl: this.$store.state.common.urlpath + '/api/fileupload/process',
      // uploadUrl: 'http://127.0.0.1:8081' + '/api/fileupload/process',
      /* items: [
        { managementthumb: require('../img/main/thumb-img.png'), managementName: '뉴럭키세븐부동산/전경숙', managementTel: '010-1192-9992', managementAddress: '서울시 동대문구 천호대로 3 7층 디에이인포메이션 포탈파트', managementArea: '서울시 동대문구 신설동', managementUrl: 'http://www.naver.com' },
        { managementthumb: require('../img/main/thumb-img.png'), managementName: '22뉴럭키세븐부동산/전경숙', managementTel: '010-1192-9992', managementAddress: '서울시 동대문구 천호대로 3 7층 디에이인포메이션 포탈파트', managementArea: '서울시 동대문구 신설동', managementUrl: 'http://www.naver.com' }
      ], */
      fields: [
        { key: 'proPicFileNm', label: '대표사진', class: 'text-center' },
        { key: 'proNm', label: '업체명/이름', class: 'text-center' },
        { key: 'proTel', label: '연락처', class: 'text-center', sortDirection: 'desc' },
        { key: 'proRegion', label: '담당구역', class: 'text-center', sortDirection: 'desc' },
        { key: 'actions', label: '', class: 'text-center' }
      ],
      totalRows: 1,
      infoModal: {
        id: 'info-modal',
        title: '전문가 추천',
        thumb: require('../img/main/thumb-img.png'),
        name: '럭키세븐부동산/전경숙',
        tel: '010-1192-9992',
        address: '서울시 동대문구 천호대로 3 7층 디에이인포메이션 포탈파트',
        addressDetail: '상세주소 입니다 아 7층예?',
        postcode: '',
        selectedType: '',
        typeKinds: [
          { value: '', text: '전문가 선택' }
        ],
        addressCitySelected: '',
        addressCountySelected: '',
        addressCity: [
          { value: '', text: '시도 선택' }
        ],
        addressCounty: [
          { value: '', text: '구군 선택' }
        ],
        url: 'http://www.naver.com'
      }
    }
  },
  created () {
    this.initProlist()
  },
  watch: {
    typePro () {
      this.itemOptions = []
      for (let i = 0; i < this.typePro.length; i++) {
        let tmp = { value: this.typePro[i].idTypePro, text: this.typePro[i].nameTypePro }
        this.itemOptions.push(tmp)
        this.infoModal.typeKinds.push(tmp)
      }
      this.typeSelected = this.typePro[0].idTypePro
      this.infoModal.proType = this.typePro[0].idTypePro
      this.initProRegion()
      this.setProlist()
    },
    totalArea () {
      this.setSidoSetting()
    },
    addressCitySelected () {
      this.setGunguSetting('outter')
      // console.log(this.addressCitySelected)
    },
    infoModal: {
      deep: true,
      handler (newData) {
        this.innerRegion = newData.addressCitySelected
        // console.log('new = ' + this.innerRegion)
      }
    },
    innerRegion () {
      this.setGunguSetting('inner')
      // console.log(this.infoModal.addressCitySelected)
    }
    /* proList () {
      for (var i = 0; i < this.proList.length; i++) {
        console.log(this.proList[i])
      }
    } */
  },
  methods: {
    initProlist () {
      this.$store.dispatch('apiTypeProlists')
    },
    initProRegion () {
      this.$store.dispatch('apiTotalArea')
    },
    setProlist () {
      this.$store.dispatch('apiProList', {'searchProType': this.typeSelected, 'searchProName': this.searchText, 'searchSido': this.addressCitySelected, 'searchGugun': this.addressCountySelected})
    },
    showModal: function () {
      this.layerPopPost = true
    },
    setSidoSetting: function () {
      var tmpArr = []
      this.addressCity = [
        { value: '', text: '시도 선택' }
      ]
      this.infoModal.addressCity = [
        { value: '', text: '시도 선택' }
      ]
      for (let i = 0; i < this.totalArea.length; i++) {
        if (tmpArr.indexOf(this.totalArea[i].sido) === -1) {
          tmpArr.push(this.totalArea[i].sido)
          const tmp = {value: this.totalArea[i].sido, text: this.totalArea[i].sido}
          this.addressCity.push(tmp)
          this.infoModal.addressCity.push(tmp)
        }
        // console.log(this.totalArea[i].sido)
      }
    },
    setGunguSetting: function (changeType) {
      let obj = ''
      if (changeType === 'inner') {
        obj = this.infoModal
      } else {
        obj = this
      }
      obj.addressCounty = [
        { value: '', text: '구군 선택' }
      ]
      if (this.innerControllFlag === false) {
        obj.addressCountySelected = ''
      } else {
        this.innerControllFlag = false
      }
      if (obj.addressCitySelected !== '') {
        for (let i = 0; i < this.totalArea.length; i++) {
          if (this.totalArea[i].sido === obj.addressCitySelected) {
            const tmp = {value: this.totalArea[i].gugun, text: this.totalArea[i].gugun}
            obj.addressCounty.push(tmp)
          }
        }
      }
    },
    getPostcode: function (show, postcode, adress) {
      if (show) {
        this.layerPopPost = false
        this.infoModal.address = adress
        this.infoModal.postcode = postcode
        this.infoModal.addressDetail = ''
      } else {
        this.layerPopPost = false
      }
    },
    newItem () {
      this.innerControllFlag = true
      this.infoModal.title = '전문가 추가하기'
      this.infoModal.thumb = ('../img/main/thumb-img.png')
      this.infoModal.proId = ''
      this.infoModal.proType = ''
      this.infoModal.name = ''
      this.infoModal.tel = ''
      this.infoModal.address = ''
      this.infoModal.addressDetail = ''
      this.infoModal.addressCitySelected = ''
      this.infoModal.addressCountySelected = ''
      this.infoModal.url = ''
      this.fileRecords = []
      this.fileRecordsForUpload = []
      this.fileRecordsForDelete = []
      this.$root.$emit('bv::show::modal', 'add-management')
    },
    modifyItem (item, index) {
      this.innerControllFlag = true
      this.infoModal.title = '전문가 수정하기'
      this.infoModal.thumb = ('../img/main/thumb-img.png')
      this.infoModal.proId = item.proId
      this.infoModal.proType = item.proType
      this.infoModal.name = item.proNm
      this.infoModal.tel = item.proTel
      this.infoModal.address = item.proAddr
      this.infoModal.addressDetail = item.proAddrDtl
      this.infoModal.addressCitySelected = item.proRegion1
      this.infoModal.addressCountySelected = item.proRegion2
      this.infoModal.url = item.proUrl
      let info = this.getFileInfo(item)
      this.fileRecords = info
      this.fileRecordsForUpload = info
      this.fileRecordsForDelete = []
      // console.log('this.fileRecords = ' + JSON.stringify(this.fileRecords))
      // console.log('this.fileRecordsForUpload = ' + JSON.stringify(this.fileRecordsForUpload))
      // console.log(item.proPicFileId) --> 7
      // console.log(item.proPicFileNm) --> uploads/pro_images/7/img_start.png
      this.$root.$emit('bv::show::modal', 'modify-management')
    },
    getFileInfo (item) {
      let obj = []
      if (item.proPicFileNm === '') {
        return obj
      } else {
        let fileArr = item.proPicFileNm.split('/')
        let file = {
          name: fileArr[fileArr.length - 1],
          file: { name: fileArr[fileArr.length - 1] },
          url: this.imgUrl + '/' + item.proPicFileNm,
          lastModified: item.proPicFileLast,
          size: item.proPicFileSize,
          type: item.proPicFileType,
          ext: item.proPicFileExt
        }
        obj.push(file)
        return obj
      }
    },
    resetInfoModal () {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    sevePro (type, obj) {
      const params = {
        'proAddr': obj.address,
        'proId': obj.proId,
        'proNm': obj.name,
        'proAddrDtl': obj.addressDetail,
        'proRegion1': obj.addressCitySelected,
        'proRegion2': obj.addressCountySelected,
        'proTel': obj.tel,
        'proType': obj.proType,
        'proUrl': obj.url,
        'flag': type
      }
      this.$store.dispatch('apiTranPro', params).then(() => {
        // console.log('this.tranProRtn = ' + this.tranProRtn)
        if (this.tranProRtn === 'addressError') {
          alert('주소 오류로 인하여 내용 변경에 실패하였습니다.')
        } else if (this.tranProRtn === 'duplicateError') {
          alert('전문가가 해당 지역에 이미 등록 되어 있습니다.')
        } else {
          if (type === 'I') {
            this.uploadFiles()
            this.$nextTick(() => {
              this.$bvModal.hide('add-management')
            })
          } else if (type === 'U') {
            // this.uploadFiles()
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              this.uploadFiles()
            }
            this.$nextTick(() => {
              this.$bvModal.hide('modify-management')
            })
          } else {
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              // console.log('this.setProlist == 1')
              this.setProlist()
            }
          }
        }
        /* if (this.tranRtnStr !== 'addressError') {
          if (type === 'I') {
            this.uploadFiles()
            this.$nextTick(() => {
              this.$bvModal.hide('add-management')
            })
          } else if (type === 'U') {
            // this.uploadFiles()
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              this.uploadFiles()
            }
            this.$nextTick(() => {
              this.$bvModal.hide('modify-management')
            })
          } else {
            if (this.fileRecordsForDelete.length > 0) {
              this.deleteUploadedFile()
            } else {
              // console.log('this.setProlist == 1')
              this.setProlist()
            }
          }
        } else {
          alert('내용 변경에 실패하였습니다.')
        } */
      })
    },
    deleteItem (item, index) {
      const deleteConfirm = confirm('정말 삭제하시겠습니까??')
      if (deleteConfirm === true) {
        this.fileRecordsForUpload = []
        this.fileRecordsForDelete = this.getFileInfo(item)
        this.sevePro('D', item)
      } else {
        return false
      }
    },
    validTranData () {
      if (this.infoModal.proType === '') {
        return '전문가 타입을 입력하세요.'
      }

      if (this.infoModal.name === '') {
        return '전문가 이름을 입력하세요.'
      }

      if (this.infoModal.tel === '') {
        return '전문가 전화번호를 입력하세요.'
      }

      if (this.infoModal.address === '') {
        return '전문가 주소를 입력하세요.'
      }

      if (this.infoModal.addressCitySelected === '') {
        return '전문가 등록 도/시 값을 입력하세요.'
      }

      if (this.infoModal.addressCountySelected === '') {
        if (this.infoModal.addressCitySelected !== '세종특별자치시') {
          return '전문가 등록 군/구 값을 입력하세요.'
        }
      }

      /* if (this.fileRecords.length === 0) {
        console.log('여기서 Error 처리를 할지 결정 = ' + JSON.stringify(this.fileRecords))
      } */

      return 'success'
    },
    itemFilter () {
      // alert('itemFilter')
      this.setProlist()
    },
    allItemFilter () {
      alert('allItemFilter')
    },
    modalAdd () {
      // alert('modalAdd')
      const str = this.validTranData()
      if (str === 'success') {
        this.sevePro('I', this.infoModal)
      } else {
        alert(str)
      }
      /* this.$nextTick(() => {
        this.$bvModal.hide('add-management')
      }) */
    },
    modifySave () {
      // alert('modifySave')
      const str = this.validTranData()
      if (str === 'success') {
        this.sevePro('U', this.infoModal)
      } else {
        alert(str)
      }
      /* this.$nextTick(() => {
        this.$bvModal.hide('modify-management')
      }) */
    },
    modalSave () {
      alert('modalSave')
      // this.items.push({내용추가})
      this.$nextTick(() => {
        this.$bvModal.hide('add-management')
      })
    },
    resetModal () {
      // alert('resetModal')
    },
    filesSelected: function (fileRecordsNewlySelected) {
      // console.log('filesSelected = ' + JSON.stringify(fileRecordsNewlySelected))
      var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
      if (this.fileRecordsForUpload.length > 1) {
        var tmpFileRecord = this.fileRecordsForUpload[0]
        // console.log('filesSelected fileRecords tmp=' + JSON.stringify(tmpFileRecord))
        this.onBeforeDelete(tmpFileRecord)
      }
      // console.log('filesSelected =' + JSON.stringify(this.fileRecords))
      // console.log('filesSelected =' + JSON.stringify(this.fileRecordsForUpload))
    },
    fileDeleted: function (fileRecord) {
      // console.log('fileDeleted = ' + JSON.stringify(fileRecord))
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      }
      /* else {
        this.deleteUploadedFile(fileRecord)
      } */
    },
    deleteUploadedFile: function () {
      // console.log('deleteUploadedFile = ' + JSON.stringify(this.fileRecordsForDelete))
      const params = {
        'deleteFiles': this.fileRecordsForDelete,
        'gubun': '03',
        'idDtFile': this.tranProRtn
      }
      this.$store.dispatch('apiDeleteFiles', params).then(() => {
        if (this.deleteFilesRtn !== 'ok') {
          alert('file을 삭제 중 이상이 발생하였습니다.')
        } else {
          this.uploadFiles()
        }
      })
    },
    onBeforeDelete: function (fileRecord) {
      // console.log('onBeforeDelete = ' + JSON.stringify(fileRecord))
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      // console.log('onBeforeDelete = ' + i)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
        // console.log(JSON.stringify(fileRecord))
        // console.log(JSON.stringify(fileRecord.url))
        let idx = JSON.stringify(fileRecord).indexOf(this.imgUrl)
        if (idx !== -1) {
          this.fileRecordsForDelete.push(fileRecord)
        }
      } else {
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord)
      }
    },
    uploadFiles: function () {
      let tranProRtn = this.tranProRtn
      // console.log('uploadFiles = ' + this.fileRecordsForUpload.length)
      if (this.fileRecordsForUpload.length > 0) {
        // console.log('uploadFiles = ' + JSON.stringify(this.fileRecordsForUpload))
        this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload, function createFormData (fileData) {
          const formData = new FormData()
          formData.append('id', tranProRtn)
          formData.append('type', '03')
          formData.append('file', fileData.file)
          return formData
        }).then(() => {
          // console.log('uploadFiles = 22')
          this.fileDataUpload()
        })
        // console.log('uploadFiles = 11')
      } else {
        const params = {
          'Gubun': '03',
          'idAtFile': this.tranProRtn,
          'flag': 'DELETE'
        }
        // console.log(params)
        this.$store.dispatch('apiAttachedFiles', params).then(() => {
          if (this.fileFlag === 'ok') {
            this.fileRecordsForUpload = []
            this.fileRecordsForDelete = []
            this.fileRecords = []
            // console.log('this.setProlist == 3')
            this.setProlist()
          }
        })
      }
    },
    fileDataUpload () {
      /* console.log('onUpload = ' + JSON.stringify(this.fileRecordsForUpload))
      console.log('type = ' + this.fileRecordsForUpload[0].type)
      console.log('size = ' + this.fileRecordsForUpload[0].size)
      console.log('ext = ' + this.fileRecordsForUpload[0].ext)
      console.log('lastModified = ' + this.fileRecordsForUpload[0].lastModified)
      console.log('lastModified = ' + this.fileRecordsForUpload[0].file.name) */
      this.AtFile = []
      this.AtFile.push({'nameAtFile': this.fileRecordsForUpload[0].file.name, 'ordAtFile': 0, 'fileType': this.fileRecordsForUpload[0].type, 'fileSize': this.fileRecordsForUpload[0].size, 'fileExt': this.fileRecordsForUpload[0].ext, 'fileMody': this.fileRecordsForUpload[0].lastModified})
      const params = {
        'Gubun': '03',
        'idAtFile': this.tranProRtn,
        'AtFile': this.AtFile,
        'flag': 'INSERT'
      }
      // console.log(params)
      this.$store.dispatch('apiAttachedFiles', params).then(() => {
        if (this.fileFlag === 'ok') {
          this.fileRecordsForUpload = []
          this.fileRecordsForDelete = []
          this.fileRecords = []
          // console.log('this.setProlist == 3')
          this.setProlist()
        }
      })
    },
    onUpload (responses) {
      // console.log('onUpload = ' + JSON.stringify(responses))
    },
    onUploadError (failedResponses) {
      alert('file 업로드 중 이상이 발생하였습니다.')
      // console.log('ERROR : ', failedResponses)
    }
  },
  computed: {
    ...mapGetters({
      typePro: 'getTypeProlists',
      totalArea: 'getTotalArea',
      items: 'getProList',
      tranProRtn: 'getTranProRtn',
      deleteFilesRtn: 'getDeleteFiles',
      fileFlag: 'getAttachedFlag'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/admin/ExpertManagement.vue